import React from "react";
import { useNavigate } from "react-router-dom";
import { useGridMenuItem } from "ag-grid-react";
import { CustomMenuItemProps } from "ag-grid-react";

export interface MiniExpertMenuItemProps extends CustomMenuItemProps {
  sjmoCode?: string;
  tableName?: string;
  id?: string;
}

export default function MiniExpertMenuItem({
  name,
  sjmoCode,
  tableName,
  id
}: MiniExpertMenuItemProps) {
  const navigate = useNavigate();

  useGridMenuItem({
    configureDefaults: () => true,
    select: () => {
      const params = new URLSearchParams();
      params.append("miniExpertTableName", tableName || "");
      params.append("miniExpertSjmoCode", sjmoCode || "");
      params.append("miniExpertEntityId", id || "");

      navigate({ search: params.toString() });
    },
  });

  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      <span className="ag-menu-option-part ag-menu-option-text">{name}</span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer"></span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer"></span>
    </div>
  );
}
